'use client';

import React from 'react';
import { cn, TSearch } from 'types';
import { IconType } from '../icons';
import { InputField } from '../input-field';

export const Search = (props: Partial<TSearch>) => {
  const { defaultValue, label, placeholder, resetSearch, onBlurDisabled, onSearch } = props;
  const [searchTerm, setSearchTerm] = React.useState(defaultValue || '');

  React.useEffect(() => {
    if (!resetSearch) {
      return;
    }
    setSearchTerm('');
    onSearch('');
  }, [defaultValue]);

  const onAction = (event: React.SyntheticEvent<HTMLInputElement>) => {
    onSearch(event?.currentTarget?.value);
  };

  const onChange = (input: string, _formatted?: string, event?: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(input);
    if (typeof props?.onChange === 'function') {
      props.onChange(event);
    }
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.which === 13) {
      (event.target as HTMLInputElement).setAttribute('isEnter', 'true');
      onAction(event);
      if (typeof props?.onEnter === 'function') {
        props.onEnter(event);
      }
    } else {
      (event.target as HTMLInputElement).setAttribute('isEnter', 'false');
    }
  };

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (typeof props?.onBlur === 'function') {
      props.onBlur(event);
    }
    if (onBlurDisabled) {
      return;
    }
    if (event.target.getAttribute('isEnter') != 'true') {
      onAction(event);
    }
  };

  return (
    <div className="flex flex-col w-full">
      <InputField
        id="searchField"
        label={label}
        type="search"
        className={cn('w-full !pl-2 indent-10', props.className)}
        startAdornment={{ content: { icon: IconType.NewNextSearch } }}
        placeholder={placeholder || null}
        aria-placeholder={placeholder || null}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onKeyDown}
        defaultValue={searchTerm}
      />
    </div>
  );
};
